import React from 'react';

const NoResults = ({passages}) => {
    return (
        <>
            {
                passages.length === 0 &&
                <div id="dataNotFound" className="alert alert-info p-2 mt-5 h6 text-center">
                    Nenhum registro encontrado.
                </div>
            }
        </>
    );
};

export default NoResults;